export default __webpack_public_path__ + "static/media/spoon_wow.e4dbaf0a.jpg";